// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oymI","colMin":"styles_colMin__1hzRu"};